<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <Input class="search-ipt" type="text" v-model="searchIpt.keyword" placeholder="请输入学生姓名" @on-enter="getStudentList" clearable/>
            <Button type="primary" icon="md-search" class="search_tn" data-level="common" @click="getStudentList">搜索</Button>
            <Button class="top_search_btn" type="primary" ghost icon="ios-funnel" @click="topSearchStatus = true">高级搜索
            </Button>
          </div>
        </div>
      </div>
      <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="tableData">
        <template slot-scope="{ row,index }" slot="schoolName">
          <div class="jump_color" @click="toSchoolDetail(row.schoolId)">{{row.schoolName}}</div>
        </template>
        <template slot-scope="{ row, index }" slot="classCount">
          <div :class="[row.classCount? 'jump_color':'']" @click="toRelationClass(row.classId)">{{row.classCount}}</div>
        </template>
        <template slot-scope="{ row, index}" slot="parentCount">
          <div :class="[row.parentCount? 'jump_color':'']" @click="toRelationParents(row.classId)">{{row.parentCount}}</div>
        </template>
        <template slot-scope="{ row, index}" slot="action">
          <a class="jump_color"  @click="deleteAllParents(row.studentId)">删除家长</a>
          <a class="jump_color"  @click="checkDetail(row)">详情</a>
        </template>
      </Table>
    </div>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getStudentList"></paging>
    <Modal class="top_search_modal" v-model="topSearchStatus" title="高级搜索">
      <div class="top_search_wrapper">
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.seniorKeyword" placeholder="请输入学生姓名或ID" clearable/>
        <!--<Cascader class="search-ipt search_item" :data="regionList" change-on-select placeholder="请选择地区"></Cascader>-->
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.region" placeholder="请输入学校地址" clearable/>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.schoolName" placeholder="请输入学校名称" clearable/>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.classId" placeholder="请输入班级ID" clearable/>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.className" placeholder="请输入班级名称" clearable/>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.parentId" placeholder="请输入家长ID" clearable/>
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="topSearchStatus = false">取消</Button>
        <Button class="add_record_btn" type="info" icon="md-search" @click="topSearchFn">搜索</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import paging from '../templates/Paging.vue';
  import {_getStudentList,_deleteAllParents} from '../api/api';
  import {alertTips } from "../common/common.js";
  export default {
    name:"Students",
    components: {paging},
    data() {
      return {
        pageSize:10, // 每页条数
        currentNum: 0, // 当前页码
        totalNum: 0, // 数据总条数
        searchLevel: 'common',// common普通搜索，senior高级搜索
        topSearchStatus:false, // 高级搜索显示状态
        searchIpt: {
          keyword: '',
          seniorKeyword: '',
          region: '',
          schoolName: '',
          classId: '',
          className: '',
          parentId:'',
        },
        tableHeader: [
          {
            title: 'ID',
            key:'studentId'
          },
//          {
//            title: '地区',
//            key:'region'
//          },
          {
            title: '学校姓名',
            key:'schoolName',
            slot: 'schoolName'
          },
          {
            title: '学生姓名',
            key:'studentName'
          },
          {
            title: '关联班级数',
            key:'classCount',
            slot: 'classCount'
          },
          {
            title: '关联家长数',
            key:'parentCount',
            slot: 'parentCount'
          },
          {
            title: '操作',
            slot: 'action'
          },
        ],
        tableData:[],
        regionList: [
          {
            value: 'beijing',
            label: '北京',
            children: [
              {
                value: 'gugong',
                label: '故宫'
              },
              {
                value: 'tiantan',
                label: '天坛'
              },
              {
                value: 'wangfujing',
                label: '王府井'
              }
            ]
          },
          {
            value: 'jiangsu',
            label: '江苏',
            children: [
              {
                value: 'nanjing',
                label: '南京',
                children: [
                  {
                    value: 'fuzimiao',
                    label: '夫子庙',
                  }
                ]
              },
              {
                value: 'suzhou',
                label: '苏州',
                children: [
                  {
                    value: 'zhuozhengyuan',
                    label: '拙政园',
                  },
                  {
                    value: 'shizilin',
                    label: '狮子林',
                  }
                ]
              }
            ],
          }
        ]
      }
    },
    methods: {
//      删除家长
      deleteAllParents(id){
        const self = this;
        _deleteAllParents(id).then(res => {
          if(res.code === 0) {
            alertTips("success", "删除成功");
            setTimeout(function () {
              self.getStudentList();
            },3000)
          }else {
            alertTips("warning", res.message);
          }
        })
      },
//      获取学生列表
      getStudentList(msg){
        const self = this;
        let params = {
          address:self.searchIpt.region,
          classId:self.searchIpt.classId,
          className:self.searchIpt.className,
          schoolName:self.searchIpt.schoolName,
          parentId:self.searchIpt.parentId,
          id: '',
          name: self.searchLevel === 'common' ? self.searchIpt.keyword :  self.searchIpt.seniorKeyword,
//          id: self.searchLevel === 'common' ?(/^\d*$/gi.test(self.searchIpt.keyword) ? self.searchIpt.keyword : '') : (/^\d*$/gi.test(self.searchIpt.seniorKeyword) ? self.searchIpt.seniorKeyword : ''),
//          name: self.searchLevel === 'common' ?(/^\d*$/gi.test(self.searchIpt.keyword) ? '' : self.searchIpt.keyword) : (/^\d*$/gi.test(self.searchIpt.seniorKeyword) ? '' : self.searchIpt.seniorKeyword),

          page: typeof(msg) === 'object' && msg.pageNum ? msg.pageNum - 1 : 0,
          size: self.pageSize
        };
        _getStudentList({params:params}).then(res => {
          if(res.code === 0) {
            self.tableData = res.data.content;
            self.totalNum = res.data.total;
          }
        })
      },
      toSchoolDetail(schoolId) {
        const self = this;
        self.$router.push(`/schools?id=${schoolId}`)
      },
//      跳转到班级列表
      toRelationClass(classId) {
        this.$router.push(`/klasses?classId=${classId}`)
      },
//      跳转到用户列表
      toRelationParents() {

      },
      checkDetail(rowData) {
        const self = this;
        self.$router.push(`/students/detail?id=${rowData.studentId}`)
      },
      topSearchFn() {
        this.searchLevel = "senior";
        this.getStudentList();
        this.searchIpt = {
          seniorKeyword: '',
          region: '',
          schoolName: '',
          classId: '',
          className: '',
          parentId:'',
        };
        this.topSearchStatus = false;
      },
      cancelSearchModel(){

      }
    },
    created() {
      if(this.$route.query.schoolName) {
        this.searchIpt.schoolName = this.$route.query.schoolName;
      }
      if(this.$route.query.name) {
        this.searchIpt.keyword = this.$route.query.name;
      }
      if(this.$route.query.classId) {
        this.searchIpt.classId = this.$route.query.classId;
      }
    },
    mounted() {
      this.getStudentList();
    }
  };
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Students.vue